import { InjectionToken } from '@angular/core';
import { IUtmParams } from '../interface';

export const UTM_PARAMS = new InjectionToken<IUtmParams[]>('UTM_PARAMS');
